// extracted by mini-css-extract-plugin
export default {"hero":"FeaturedPost_hero__jdlOn","copy-container":"FeaturedPost_copy-container__Vh20N","copy":"FeaturedPost_copy__aqR-o"};